import { Injectable, OnDestroy } from '@angular/core';
import { SplitFactory } from '@splitsoftware/splitio';

import { EnvironmentVariablesService } from '../environment-variables.service';

@Injectable({
  providedIn: 'root',
})
export class SplitService implements OnDestroy {
  client: SplitIO.IBrowserClient;

  constructor(private environmentVariables: EnvironmentVariablesService) {}

  initialize(email: string): void {
    const factory: SplitIO.IBrowserSDK = SplitFactory({
      core: {
        authorizationKey: this.environmentVariables.SPLIT_KEY,
        key: email.toLowerCase(),
      },
      startup: {
        readyTimeout: 1.5, // seconds
      },
    });
    this.client = factory.client();
  }

  ngOnDestroy(): void {
    this.client.destroy();
  }

  isOn(split: string): boolean {
    if (this.client) {
      return this.client.getTreatment(split) === 'on';
    }
    return false;
  }
}
